import { guid } from 'app/shared/lib/guid';
import { bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';

export class EssFile {

    @bindable.string()
    public testName: string = '';

    @bindable.boolean
    public uploading: boolean = false;

    @bindable.booleanAttr
    public multiple: boolean = false;

    @bindable.any({ defaultBindingMode: bindingMode.twoWay })
    public file: File | File[] | null = null;

    @bindable.boolean()
    public required: boolean = false;

    protected id: guid = guid();
    protected icon: string | null = null;

    // refs

    private $fileInputElement!: HTMLInputElement;
    private $filePathInputElement!: HTMLInputElement;

    protected fileChanged(newValue: any): void {
        if(!newValue) {
            this.file = null;
            if(this.$fileInputElement) {
                this.$fileInputElement.value = '';
                this.$fileInputElement.value = <any>null;
            }
            if(this.$filePathInputElement) {
                this.$filePathInputElement.value = '';
            }
        }
    }

    protected handleFileChanged(event: Event): void {
        if(this.$fileInputElement.files && this.$fileInputElement.files.length > 0) {
            if(this.multiple) {
                this.file = Array.from(this.$fileInputElement.files);
                this.icon = 'ui:icons.files.multiple';
            }
            else {
                this.file = this.$fileInputElement.files[0];
                this.icon = 'ui:icons.files.multiple';
            }
        }
        else {
            this.file = null;
            this.icon = null;
        }
    }

}
